if (!window.Eurus.loadedScript.has('locales-form.js')) {
  window.Eurus.loadedScript.add('locales-form.js');

  // Casa Limpida 20/10/2026 : le script arrive parfois apres le demarrage d'Alpine, l'evenement
  // alpine:init est alors deja passe et le selecteur de langue ne marche pas. On enregistre tout de suite
  // si Alpine tourne deja, puis on reinitialise les selecteurs deja rendus.
  const cslLocReg = () => {
      Alpine.data('xLocalizationForm', () => ({ 
        openCountry: false,
        loading: false,
        cachedResults: false,
        submit(value, input) {
          this.$el.closest("#localization_form").querySelector('#'+input).value = value;
          this.$el.closest("#localization_form").submit();
        },
        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true
          }
          let countrySelector = el.closest(".country-selector");
          let optionEL = countrySelector.querySelector(".country-options");

          this.loading = true;
          fetch(window.Shopify.routes.root + '?section_id=country-selector')
          .then(reponse => {
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const content = parser.parseFromString(response,'text/html').getElementById("list-country").innerHTML;
            optionEL.innerHTML = content;
            this.cachedResults = true;
            this.openCountry = true;
          })
          .finally(() => {
            this.loading = false;
          })
        },
      }))
  };
  if (window.Alpine && typeof window.Alpine.data === 'function') {
    cslLocReg();
    document.querySelectorAll('[x-data="xLocalizationForm"]').forEach((el) => {
      // seulement les selecteurs qu'Alpine a deja tente d'initialiser (sinon il le fera lui-meme au demarrage)
      if (!Object.keys(el).some((k) => k.indexOf('_x_') === 0)) return;
      if (window.Alpine.destroyTree) window.Alpine.destroyTree(el);
      window.Alpine.initTree(el);
    });
  } else {
    document.addEventListener('alpine:init', cslLocReg);
  }
}
